import axios from "axios";
import * as _ from "lodash";
import React, { useContext, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import Context from "../../context/Context";
import { useUserAuth } from "../../context/UserAuthContext";
import "./Showcase.css";
import styles from "./showcase.module.css";

const ServiceFormInput = ({
  setServiceForm,
  orgDomain,
  mail,
  setShowTerms,
}) => {
  // const [name, setName] = useState('')
  // const [email, setEmail] = useState('')
  // const [phone, setPhone] = useState("")
  // const [requirment, setRequirement] = useState("")
  // const [tc, setTc] = useState(false)
  const [formErrors, setFormErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const { currentUser, setPreviousLocation } = useUserAuth();
  const { userIdToken } = useContext(Context);
  const token = userIdToken || currentUser?.accessToken;
  const location = useLocation();

  const tinyUrl = window.location.pathname.split("/")[1];
  console.log("tinyUrl", tinyUrl);
  const organizerId = tinyUrl.split("o").pop().split("c")[0];
  const campaignId = tinyUrl.split("p").pop().split("c")[0];
  const navigate = useNavigate();

  const initialValues = {
    name: "",
    userEmail: "",
    email: mail,
    phone: "",
    requirment: "",
    tc: false,
  };
  const [formValues, setFormValues] = useState(initialValues);

  const validateEmail = (emailAdress) => {
    // eslint-disable-next-line no-useless-escape
    let regexEmail =
      // eslint-disable-next-line no-useless-escape
      /^([a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;

    if (emailAdress.match(regexEmail)) {
      return true;
    } else {
      return false;
    }
  };
  const validatePhone = (number) => {
    let regexmobile =
      // eslint-disable-next-line no-useless-escape
      /^(?:(?:\+|0{0,2})91(\s*[\-]\s*)?|[0]?)?[789]\d{9}$/;

    if (number.match(regexmobile)) {
      return true;
    } else {
      return false;
    }
  };

  const submitFormApi = async () => {
    setLoading(true);
    try {
      let config = {
        method: "post",
        url: `${process.env.REACT_APP_SHARE_FORM_DATA}/${organizerId}/${campaignId}`,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        data: formValues,
      };
      const response = await axios(config);
      setLoading(false);
      setServiceForm(false);
      navigate(`/${tinyUrl}`);
      return response;
    } catch (error) {
      console.log(error.message);
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormErrors(validate(formValues));

    if (
      !_.isEmpty(formValues.name) &&
      !_.isEmpty(formValues.userEmail) &&
      !_.isEmpty(formValues.phone) &&
      !_.isEmpty(formValues.requirment) &&
      formValues.tc === true
    ) {
      submitFormApi();
    }
  };
  const validate = (values) => {
    const errors = {};
    if (_.isEmpty(values.name)) {
      errors.name = "This field is required";
    }
    if (_.isEmpty(values.userEmail)) {
      errors.userEmail = "This field is required  ";
    } else if (!validateEmail(values.userEmail)) {
      errors.userEmail = "Please enter a valid Email";
    }
    if (_.isEmpty(values.phone)) {
      errors.phone = "This field is required  ";
    } else if (!validatePhone(values.phone)) {
      errors.phone = "Please enter a valid phone number";
    }
    if (_.isEmpty(values.requirment)) {
      errors.requirment = "This field is required  ";
    }
    if (values.tc === false) {
      errors.tc = "Please accept the terms and conditions ";
    }
    return errors;
  };

  const handleLogin = () => {
    setPreviousLocation(window.location.pathname);
    navigate(`/signup`, {
      state: {
        submitForm: true,
        previousLocation: location?.pathname,
      },
    });
  };
  return (
    <div className="h-[100%] w-[100%] text-black px-[16px] md:px-[12%] py-[3%]">
      <p className="leadcardtext">
        Please fill all the data to connect with us
      </p>
      {/* <p className="formdesc mt-[16px]">
        We will help you to make your special day even more colourfull &
        memorable. Book your place and celebrate your momentCorniche Resto.
      </p> */}
      <div className="mt-[20px]">
        <input
          placeholder="Name"
          className="w-[100%] border-2 rounded-md px-[16px] py-[15px] mt-[20px] outline-none"
          type="text"
          onChange={(e) =>
            setFormValues({
              ...formValues,
              name: e.target.value,
            })
          }
        />
        {formErrors.name && (
          <span className={styles.error}>
            <span className="text-red-600">*</span>
            {formErrors.name}
          </span>
        )}

        <input
          placeholder="Email"
          className="w-[100%] border-2 rounded-md px-[16px] py-[15px] mt-[20px] outline-none"
          type="text"
          onChange={(e) =>
            setFormValues({
              ...formValues,
              userEmail: e.target.value,
            })
          }
        />
        {formErrors.userEmail && (
          <span className={styles.error}>
            <span className="text-red-600">*</span>
            {formErrors.userEmail}
          </span>
        )}
        <input
          placeholder="Mobile Number"
          className="w-[100%] border-2 rounded-md px-[16px] py-[15px] mt-[20px] outline-none"
          type="text"
          // value={participantName}
          onChange={(e) =>
            setFormValues({
              ...formValues,
              phone: e.target.value,
            })
          }
        />
        {formErrors.phone && (
          <span className={styles.error}>
            <span className="text-red-600">*</span>
            {formErrors.phone}
          </span>
        )}
        {/* <input
          placeholder="Phone Number"
          className="w-[100%] border-2 rounded-md p-[1%]"
          type="text"
          // value={participantName}
          // onChange={(e) => setParticipantName(e.target.value)}
        /> */}
        <textarea
          placeholder="Post your requirments"
          className="w-[100%] border-2 rounded-md px-[16px] py-[15px] h-[100px] mt-[20px] outline-none"
          type="text"
          // value={participantName}
          onChange={(e) =>
            setFormValues({
              ...formValues,
              requirment: e.target.value,
            })
          }
        />
        {formErrors.requirment && (
          <span className={styles.error}>
            <span className="text-red-600">*</span>
            {formErrors.requirment}
          </span>
        )}
        <div className="flex justify-start gap-[10px] mt-[25px]">
          <input
            type="checkbox"
            id="tc"
            name="tc"
            value=""
            // checked={true}
            onClick={() =>
              formValues.newsletterRecipient === true
                ? setFormValues({
                    ...formValues,
                    tc: false,
                  })
                : setFormValues({
                    ...formValues,
                    tc: true,
                  })
            }
            className="w-[30px] h-[30px] rounded-[5px] "
          ></input>
          <label
            htmlFor="tc"
            className="text-[#171717] font-Inter font-[400] text-[14px] leading-[24px]"
          >
            Yes I agree to the{" "}
            <span
              className="text-blue-500 hover:cursor-pointer"
              onClick={() => setShowTerms(true)}
            >
              Terms & Conditions
            </span>{" "}
            of GoViral. Hereby agree to be contacted for enquiry purpose of the
            same.
          </label>
        </div>

        {formErrors.tc && (
          <span className={styles.error}>
            <span className="text-red-600">*</span>
            {formErrors.tc}
          </span>
        )}
      </div>
      <div className="w-[100%] flex justify-center mt-[30px]">
        {loading ? (
          <button
            className="h-[52px] w-auto px-[20px] bg-[#5073EF] rounded-full flex justify-center items-center text-white"
            disabled
          >
            Submiting..
          </button>
        ) : (
          <button
            className="h-[52px] w-auto px-[20px] bg-[#5073EF] rounded-full flex justify-center items-center text-white"
            onClick={currentUser === null ? () => handleLogin() : handleSubmit}
          >
            Post your requirements
          </button>
        )}
      </div>
    </div>
  );
};

export default ServiceFormInput;
